import Confirmation from './Confirmation'
import connect from './connect'

export default connect(Confirmation)
